import { ReactNode } from "react";

import { Typography } from "@mui/material";

import { useMediaQueryBreakpoint } from "@hooks/useMediaQueryBreakpoint";

import {
  CardContainer,
  CardDescription,
  CardShadow,
  CardType,
  TextIcon,
} from "./Card.styled";

interface CardProps {
  type: CardType;
  icon: ReactNode | string;
  title: string;
  children?: ReactNode;
  className?: string;
}

export const Card = ({ type, icon, title, children, className }: CardProps) => {
  const { isDesktop: isLg, isTablet: isMd } = useMediaQueryBreakpoint();

  const problemHeaderVariant = isLg
    ? "paragraph_large_medium"
    : "paragraph_medium_medium";
  const technologyHeaderVariant = isMd
    ? "paragraph_large_medium"
    : "paragraph_medium_medium";

  return (
    <CardContainer type={type} className={className}>
      <CardShadow />

      {typeof icon === "string" ? <TextIcon>{icon}</TextIcon> : icon}

      <div className="flex flex-col gap-2">
        <Typography
          variant={
            type === "problem" ? problemHeaderVariant : technologyHeaderVariant
          }
        >
          {title}
        </Typography>

        <CardDescription variant="paragraph_small_regular">
          {children}
        </CardDescription>
      </div>
    </CardContainer>
  );
};
